export const newsData = [
  {
    id: 1,
    date: '2025.01.15',
    category: '重要',
    title: '【岡山市インフルエンザ情報】予防接種の予約を受付中です。お早めにご予約ください。'
  },
  {
    id: 2,
    date: '2025.01.10',
    category: '休診',
    title: '1月20日（月）は院長研修のため休診とさせていただきます。'
  },
  {
    id: 3,
    date: '2025.01.05',
    category: 'お知らせ',
    title: '【岡山市の保護者様へ】乳幼児健診の予約枠を拡大しました。'
  },
  {
    id: 4,
    date: '2024.12.25',
    category: 'お知らせ',
    title: '年末年始の診療スケジュールについて（12月29日〜1月3日休診）'
  }
];

export const faqData = [
  {
    id: 1,
    question: '岡山市外からでも受診できますか？',
    answer: 'はい、もちろん可能です。岡山市北区を中心に、倉敷市、総社市、赤磐市など近隣市町村からも多くの患者様にご来院いただいております。駐車場も完備しておりますので、お車でのご来院も便利です。'
  },
  {
    id: 2,
    question: '予約なしでも診てもらえますか？',
    answer: '予約優先制となっておりますが、急な発熱や体調不良の場合は当日受付も可能です。ただし、待ち時間が長くなる場合がございますので、できるだけ事前のご予約をおすすめしております。お電話またはWebからご予約ください。'
  },
  {
    id: 3,
    question: '予防接種は何歳から受けられますか？',
    answer: '生後2ヶ月からの定期接種に対応しております。ヒブワクチン、小児用肺炎球菌ワクチン、B型肝炎ワクチンなど、お子様の月齢に合わせた予防接種スケジュールをご提案いたします。岡山市の予防接種助成制度もご利用いただけます。'
  },
  {
    id: 4,
    question: '駐車場はありますか？',
    answer: 'はい、クリニック専用の駐車場を10台分ご用意しております。岡山市北区の便利な立地で、お車でのアクセスも良好です。満車の場合は近隣のコインパーキングもご利用いただけます。'
  },
  {
    id: 5,
    question: 'アレルギー検査はできますか？',
    answer: 'はい、血液検査による各種アレルギー検査を実施しております。食物アレルギー、花粉症、ハウスダストなど、お子様の症状に応じた検査項目をご提案いたします。岡山市の小児アレルギー専門医として、適切な診断と治療を行います。'
  },
  {
    id: 6,
    question: '育児相談だけでも受診できますか？',
    answer: 'もちろん可能です。離乳食の進め方、夜泣き、発達の心配など、子育てに関するどんな小さな悩みでもお気軽にご相談ください。岡山市で25年以上の小児科診療経験を持つ院長が、丁寧にアドバイスさせていただきます。'
  }
];
